<template>
  <div>
    <div class="grid grid-cols-5 mb-5">
      <div class="col-span-5">
        <h1 class="text-xl font-bold text-gray-700">Albums</h1>
      </div>

      <div>
        <base-label>Date</base-label>
        <el-date-picker
          style="width: 90%"
          v-model="date"
          type="date"
          placeholder="Select a date"
          format="MM/dd/yyyy"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>

      <div>
        <base-label>Outfitter</base-label>
        <el-select
          v-model="outfitter"
          filterable
          placeholder="Select"
          style="width: 90%"
        >
          <el-option
            v-for="outfitter in outfitters"
            :key="outfitter.id"
            :label="outfitter.name"
            :value="outfitter.id"
          >
          </el-option>
        </el-select>
      </div>
      <div>
        <base-label>River Section</base-label>
        <el-select
          v-model="section"
          filterable
          placeholder="Select"
          style="width: 90%"
        >
          <el-option
            v-for="riverSection in riverSections"
            :key="riverSection.id"
            :label="riverSection.river.name.concat(' - ', riverSection.name)"
            :value="riverSection.id"
          >
          </el-option>
        </el-select>
      </div>
      <div>
        <base-button-primary @click="search" class="mt-5"
          >Search</base-button-primary
        >
      </div>
    </div>
    <div class="mb-3">
      <div class="w-full">
        <vue-good-table
          :columns="columns"
          :rows="albums"
          :search-options="{ enabled: true }"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'name', type: 'asc' },
          }"
          :fixed-header="false"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 50,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            dropdownAllowAll: false,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'id'">
              <base-button-primary-extra-small @click="handleEdit(props.row)">
                Edit
              </base-button-primary-extra-small>
              <base-button-white-extra-small
                class="ml-1"
                @click="handleDelete(props.row)"
              >
                Delete
              </base-button-white-extra-small>
            </span>
            <span v-else-if="props.column.field == 'photos'">
              {{ props.row.photos.length }}
            </span>
            <span v-else-if="props.column.field == 'name'">
              <span @click="handleNameClick(props.row)">{{
                props.row.name
              }}</span>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
    <album
      :original-album="album"
      :show-modal="showModal"
      @close="showModal = false"
      @save="handleSave"
    />
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import BaseButtonPrimary from "../ui/buttons/BaseButtonPrimary";
import BaseButtonPrimaryExtraSmall from "../ui/buttons/BaseButtonPrimaryExtraSmall";
import BaseButtonWhiteExtraSmall from "../ui/buttons/BaseButtonWhiteExtraSmall";
import BaseLabel from "../ui/forms/BaseLabel";
import Album from "../photographer/Album";
export default {
  name: "Albums",
  components: {
    BaseLabel,
    VueGoodTable,
    BaseButtonPrimary,
    BaseButtonPrimaryExtraSmall,
    BaseButtonWhiteExtraSmall,
    Album,
  },
  data() {
    return {
      showModal: false,
      albums: [],
      album: {},
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Photos",
          field: "photos",
        },
        {
          label: "",
          field: "id",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    handleNameClick(row) {
      this.$router.push("/photographer/" + row.id);
    },
    handleDelete(row) {
      if (confirm("Are you sure you want to delete this album?")) {
        this.$store.dispatch("album/delete", row.id).then((resp) => {
          if (!resp.success) {
            this.$notify({
              title: "Error",
              message: "There was a problem deleting this album",
              type: "error",
            });
            return;
          }
          this.search();
        });
      }
    },
    handleEdit(row) {
      this.album = row;
      this.showModal = true;
    },
    handleSave() {
      this.showModal = false;
      this.search();
    },
    search() {
      if (!this.date) {
        this.$notify({
          title: "Albums",
          message: "Date is required",
          type: "warning",
        });
        return;
      }
      this.$notify({
        title: "Albums",
        message: "Fetching data...",
        type: "success",
      });
      const data = {
        date: this.date,
        outfitter: this.outfitter,
        section: this.section,
      };
      this.$store.dispatch("album/search", data).then((resp) => {
        this.albums = [];
        if (!resp.success) {
          this.$notify({
            title: "Error",
            message: "There was a problem fetching albums",
            type: "error",
          });
          return;
        }
        this.albums = resp.albums;
      });
    },
  },
  computed: {
    date: {
      get() {
        const albumsData = this.$store.getters["misc/getAlbumsData"];
        return albumsData.date;
      },
      set(value) {
        this.$store.dispatch("misc/set_albums_date", value);
      },
    },
    outfitter: {
      get() {
        const albumsData = this.$store.getters["misc/getAlbumsData"];
        return albumsData.outfitter;
      },
      set(value) {
        this.$store.dispatch("misc/set_albums_outfitter", value);
      },
    },
    section: {
      get() {
        const albumsData = this.$store.getters["misc/getAlbumsData"];
        return albumsData.section;
      },
      set(value) {
        this.$store.dispatch("misc/set_albums_section", value);
      },
    },
    outfitters: function () {
      return this.$store.getters["outfitter/getOutfitters"];
    },
    riverSections: function () {
      return this.$store.getters["riverSection/getRiverSections"];
    },
  },
  mounted() {
    this.$store.dispatch("outfitter/all", { withDeleted: 0 });
    this.$store.dispatch("riverSection/all", { withDeleted: 0 });
    this.$store.dispatch("photographer/all");
  },
};
</script>

<style scoped></style>
